import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=dfc9739e&scoped=true"
import script from "./UserAvatar.vue?vue&type=script&lang=ts"
export * from "./UserAvatar.vue?vue&type=script&lang=ts"
import style0 from "./UserAvatar.vue?vue&type=style&index=0&id=dfc9739e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc9739e",
  null
  
)

export default component.exports